// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"510":"6795ebef","565":"edc21ba7","585":"c2be3b76","779":"4515d3de","861":"0b8cbabf"}[chunkId] + ".chunk.css";
};